import "./Dashbord.css";
import React from "react";
import Form from "react-bootstrap/Form";
import CardsCourses from "../../../Component/CardsCourses/CardsCourses";
import CardsAdmin from "../../../Component/CardsAdmin/CardsAdmin";
import CardsProfsActifs from "../../../Component/CardsProfsActifs/CardsProfsActifs";
import { ImUserTie } from "react-icons/im"
import { GiBookmarklet } from "react-icons/gi"
import { FaUserGraduate } from "react-icons/fa"
import { Card, Col, ListGroup, Row } from "react-bootstrap";

function template() {
  const cardProfs = [
    { titres: "Professeurs actifs", prenom: "omar gaye" },
    { titres: "Cours récements ajoutés", prenom: "omar gaye" },
    { titres: "Professeurs actifs", prenom: "omar gaye" },
    { titres: "Cours récements ajoutés", prenom: "omar gaye" }
  ]
  const cardData = [
    { titre: "Professeurs", text: 'professeurs', icon: <ImUserTie />, nombre: 150, couleur: 'red' },
    { titre: "courses", text: 'courses', icon: <GiBookmarklet />, nombre: 150, couleur: 'blue' },
    { titre: "students", text: 'students', icon: <FaUserGraduate />, nombre: 150, couleur: "green" },
  ]
  return (
    <div id="dasboardAdmin" className="container">

      <div className="d-flex justify-content-between ">
        <h3 className="pt-2 ">DASHBOARD</h3>
        <div>
          <Form className="d-flex ms-auto">
            <Form.Control
              type="Date"
              placeholder="select date"
              className="me-2"
              aria-label="Date"
            />

          </Form>
        </div>


        <hr />
      </div>
      <div className="container-fluid">
        <Row className="py-4">
          {
            cardData.map(({ titre, text, icon, nombre, couleur }, index) =>
              <Col className="px-0 pe-3" md={4} key={index}>
                <CardsAdmin
                  titre={titre}
                  icon={icon}
                  nombre={nombre}
                  text={text}
                  couleur={couleur}
                  className='pe-2'
                />
              </Col>
            )
          }
        </Row>
      </div>
      <div className="container-fluid">
        <Row>

          <Col lg={6} className="px-0 pe-3 pt-3">
            <Card>
              <Card.Title className="d-flex justify-content-between pt-3 px-3">
                <h4>Professeurs actifs</h4><button className="btn132 px-3">View all</button>
              </Card.Title>
              <ListGroup className="list-group-flush">

              </ListGroup>
            </Card>
            {
              cardProfs.map(({ titres, prenom }, index) =>
                <CardsCourses
                  key={index}
                  titres={titres}
                  prenom={prenom}
                />
              )
            }
          </Col>
          <Col lg={6} className=" pt-3">
            <Card>
              <Card.Title className="d-flex justify-content-between pt-3 px-3">
                <h4>Recents courses</h4><button className="btn132 px-3">View all</button>
              </Card.Title>
              <ListGroup className="list-group-flush">

              </ListGroup>
            </Card>
            {
              cardProfs.map(({ titres, prenom }, index) =>
                <CardsProfsActifs
                  key={index}
                  titres={titres}
                  prenom={prenom}
                />
              )
            }
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default template;
